var map = {
	"./bath.json": 6949,
	"./bedroom.json": 4288,
	"./kitchen.json": 459,
	"./living.json": 5706,
	"./other.json": 3175,
	"./outdoor.json": 7799,
	"./styled.json": 362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9511;